// The approval pinned above a task's chat (D85).
export default {
  label: "Pending approval",
  title: "Waiting for your approval",
  after: (step: string) => `After ${step}`,
  reported: "What the step reported",
  noteLabel: "Note for the next step (optional)",
  notePlaceholder: "For example: use V5 instead of V4",
  noteHint: "Encrypted on this browser. The next step reads it as instructions from you.",
  noteSelfManaged: "Notes reach the next step only with a managed account key. Answer here, then tell the agent in the chat when the step runs.",
  noteNoKey: "This browser cannot open the task's conversation yet, so a note cannot be sent.",
  answerWithNote: (option: string) => `${option} with note`,
  answered: (option: string) => `Answered “${option}”`,
  answeredWithNote: (option: string) => `Answered “${option}”; the note goes to the next step`,
  linkFirst: "Link this browser to answer from here.",
  linkLink: "Devices",
};
